<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Listado de Salidas
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-6
            input#allH.is-checkradio.is-black(type='radio', value='ALL' v-model='query' checked='checked')
            label.is-size-6(for='allH') Todos
            input#eb04H.is-checkradio.is-black(type='radio', value='EB04' v-model='query')
            label.is-size-6(for='eb04H') EB04
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='query')
            label.is-size-6(for='tpaH') TPA
            input#irgeH.is-checkradio.is-black(type='radio', value='IRGE' v-model='query')
            label.is-size-6(for='irgeH') IRGE
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='query')
            label.is-size-6(for='corpH') CORP.
            input#ductoH.is-checkradio.is-black(type='radio', value='DUCTO' v-model='query')
            label.is-size-6(for='ductoH') DUCTO
          .column.is-offset-2.is-4
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar artículos.. /recibe / ubicación / entrega',
                  v-model="query_articulos",
                )
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns(v-show="hayDatos")
          .column.is-12.has-text-centered
            .table-responsive
              table#tbExistencias.table.is-striped.is-fullwidth
                thead
                  tr
                    th id Salida
                    th Entrega
                    th Traslada
                    th Recibe
                    th Movimiento
                    th Área
                    th Fecha Registro
                tbody
                  tr(v-for="(data, index) in salidasSelect" :key="data.id")
                    td 
                      a.button.is-black.is-small(@click="irSalidaDetalle(data)") {{ data.id_salida }}
                    td
                      span.tag.is-primary
                        | {{ data.entrega }}
                      | &nbsp
                      a.button.is-small.is-rounded(@click="firmar(data, 1)" :class="data.firma_entrega===''? 'is-warning' : 'is-success'")
                        i.fas.fa-signature
                    td
                      span.tag.is-dark
                        | {{ data.traslada }}&nbsp
                      | &nbsp
                      a.button.is-small.is-rounded(@click="firmar(data, 2)" :class="data.firma_traslada===''? 'is-warning' : 'is-success'")
                        i.fas.fa-signature
                    td 
                      span.tag.is-dark
                        | {{ data.recibe }}&nbsp
                      a.button.is-small.is-rounded(@click="firmar(data, 3)" :class="data.firma_recibe===''? 'is-warning' : 'is-success'")
                        i.fas.fa-signature
                    td {{ data.origen }} - {{ data.destino }}
                    td {{ data.area | categoriaToHtml }}
                    td.is-size-7 {{ data.fechaReg }}
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
        .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import { mapState } from 'vuex'

export default {
  name: 'SalidasInv',
  components: { Loader, NavBarInventario },
  data () {
    return {
      isLoading: true,
      salidas: [],
      salidasSelect: [],
      hayDatos: false,
      tipos: [],
      query_articulos: '',
      query: 'ALL',
      result_query:''
    }
  },
  watch: {
    query () {
      if (this.query !== '') {
        console.log('filter')
        if (this.query === 'ALL') {
          this.salidasSelect = this.salidas
        } else {

          let salidaFilter = []
          switch (this.query) {
            case 'DUCTO':
              salidaFilter = this.salidas.filter( (salida) => salida.origen === 'EB00' || salida.destino === 'EB00' || salida.origen === 'EB01' || salida.origen === 'EB02' || salida.origen === 'ERM' || salida.origen === 'LPGD' || salida.destino === 'EB01' || salida.destino === 'EB02' || salida.destino === 'ERM' || salida.destino === 'LPGD')
              this.salidasSelect = salidaFilter
              break
            case 'TPA':
              salidaFilter = this.salidas.filter( (salida) =>  salida.origen === 'TPA' ||  salida.destino === 'TPA')
              this.salidasSelect = salidaFilter
              break
            case 'EB04':
              salidaFilter = this.salidas.filter( (salida) => salida.origen === 'EB04' || salida.destino === 'EB04')
              this.salidasSelect = salidaFilter
              break
            case 'CORP':
              salidaFilter = this.salidas.filter( (salida) => salida.origen === 'CORP' || salida.destino === 'CORP')
              this.salidasSelect = salidaFilter
              break
            case 'IRGE':
              salidaFilter = this.salidas.filter( (salida) => salida.origen === 'IRGE' || salida.destino === 'IRGE')
              this.salidasSelect = salidaFilter
              break
          
            default:
              this.salidasSelect = this.salidas
              break
          }

          
        }
      } else {
        console.log('filter vacio')
        this.salidasSelect = this.salidas
      }
    },
    query_articulos() {
      console.log(this.query_articulos)
      const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
      if (this.query_articulos.length !== 0) {
        const salidaFilter = this.salidas.filter( salida => { 
          return `${salida.recibe} ${salida.destino} ${salida.entrega} ${salida.ubicacion}`.toUpperCase().includes(QUERY_ARTICULOS)
        }) 
        console.log(salidaFilter)
        this.salidasSelect = salidaFilter
        this.result_query = this.salidasSelect.length === 1 ? `Se encontró ${this.salidasSelect.length} coincidencia.` : `Se encontraron ${this.salidasSelect.length} coincidencias.`
      } else {
        this.salidasSelect = this.salidas
        this.result_query = ''
      }
    }
  },
  methods: {
    obtenerDataSalidas () {
      InventarioServices.getSalidas()
        .then(res => {
          console.log(res)
          if (res.length > 0) {
            console.log(res)
            this.salidas = res
            this.salidasSelect = this.salidas
            
            if (this.salidasSelect.length == 0) {
              this.hayDatos = false
            } else {
              this.hayDatos = true
            }
              this.isLoading = false
          } else {
            this.isLoading = false
            this.hayDatos = false
          }
        })
    },
    irSalidaDetalle (data) {
      setTimeout(() => {
        this.$store.commit('detalleSalida', data)
        this.$router.push('/Inventario/Salida/Detalle')
      }, 150)
    },
    firmar(data, estadoF) {
      let myObj = {}
      switch (estadoF) {
        case 1:
          if (this.userLogin.id === data.id_entrega) {
            console.log('Pasa a firma del Usuario')
            myObj = {
              num: data.num,
              id_salida: data.id_salida,
              fechaReg: data.fechaReg,
              id_entrega: data.id_entrega,
              entrega: data.entrega,
              id_traslada: data.id_traslada,
              traslada: data.traslada,
              id_recibe: data.id_recibe,
              recibe: data.recibe,
              id_autoriza: data.id_autoriza,
              autoriza: data.autoriza,
              origen: data.origen,
              destino: data.destino,
              area: data.area,
              estado: estadoF,
              hash: data.hash,
              firma_entrega: data.firma_entrega,
              firma_traslada: data.firma_traslada,
              firma_recibe: data.firma_recibe
            }
            this.firmarSalida(myObj)
          } else {
            console.log('')
            this.displayToast('No es el usuario que entrega.', 'ban', 'Ok')
          }
          break
        case 2:
          myObj = {
            num: data.num,
            id_salida: data.id_salida,
            fechaReg: data.fechaReg,
            id_entrega: data.id_entrega,
            entrega: data.entrega,
            id_traslada: data.id_traslada,
            traslada: data.traslada,
            id_recibe: data.id_recibe,
            recibe: data.recibe,
            id_autoriza: data.id_autoriza,
            autoriza: data.autoriza,
            origen: data.origen,
            destino: data.destino,
            area: data.area,
            estado: estadoF,
            hash: data.hash,
            firma_entrega: data.firma_entrega,
            firma_traslada: data.firma_traslada,
            firma_recibe: data.firma_recibe
          }
          this.firmarSalida(myObj)
           
          break
        case 3:
          myObj = {
            num: data.num,
            id_salida: data.id_salida,
            fechaReg: data.fechaReg,
            id_entrega: data.id_entrega,
            entrega: data.entrega,
            id_traslada: data.id_traslada,
            traslada: data.traslada,
            id_recibe: data.id_recibe,
            recibe: data.recibe,
            id_autoriza: data.id_autoriza,
            autoriza: data.autoriza,
            origen: data.origen,
            destino: data.destino,
            area: data.area,
            estado: estadoF,
            hash: data.hash,
            firma_entrega: data.firma_entrega,
            firma_traslada: data.firma_traslada,
            firma_recibe: data.firma_recibe
          }
          this.firmarSalida(myObj)
          break
        default:
          break
      }
    },
    firmarSalida(salida) {
      console.log(salida)
      this.isLoading = false
      return
      this.$store.commit('firmarSalida', salida)
      this.$router.push('/Inventario/Salida/Firma')
    },
    displayToast(text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    backPage() {
      this.$router.back()
    }
  },
  created () {
    this.obtenerDataSalidas() 
  },
  computed: {
    ...mapState(['userLogin'])
  }
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }

  .table-responsive {
    overflow-x: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/SalidasInv.vue